// extracted by mini-css-extract-plugin
export default {"columnsContainer":"CardController_columnsContainer__ZuIpR"};